<template>
  <div class="freeEditorial freeEditorialParsys parsys">
    <div class="contentZone section">
      <div class="content-zone container">
        <div class="link-zone">
          <div class="title">
          </div>
          <div class="columns parsys">
            <div class="columns column section columns12">
              <div class="grid-row">
                <div class="col-12">
                  <div class="pageHeader">
                    <div class="c_023 ">
                      <div class="container-inner">
                        <div class="c_023-1 default">
                          <div class="heading-group">
                            <h2><span>Hvala vam što ste rezervisali probnu vožnju.</span></h2>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="grid-row">
                <div class="col-12">
                  <div class="parsys col1-par">
                    <div class="dynamicThankyou section">
                      <div class="c_026" data-lead-id="RSIJHAIWVRH">
                        <div class="text-content" data-lead-id="RSIJHAIWVRH">
                          <p style="font-family: tahoma, arial, helvetica, sans-serif; font-size: 18px;">Uskoro će vas kontaktirati prodajni savetnik iz ovlašćenog Nissan salona.<br>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'

export default {
  name: 'Form',
  data () {
    return {
      zoom: 10
    }
  },
  methods: {
    mapsUrl () {
      return 'https://maps.google.com/maps?daddr=' + this.$store.state.form.dealer.pos.lat + ',' + this.$store.state.form.dealer.pos.lng + '&amp;saddr='
    }
  },
  mounted () {
    $('html, body').animate({
      scrollTop: 30
    }, 600)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.heading-group h2 {
  font-size: 34px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/ThankYou.vue